import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../../lib/api";
import { Button } from "../ui/button";
import { Badge } from "../ui/badge";
import { BookOpenText, CheckCircle } from "@phosphor-icons/react";
import { fmtDate } from "../../lib/dateUtil";

/** My Work card: approved policies/documents I must read and sign, and the ones I've already acknowledged. */
export default function OperativeDocumentsCard() {
  const navigate = useNavigate();
  const [d, setD] = useState(null);
  useEffect(() => { API.get("/in-house-portal/documents").then(({ data }) => setD(data)).catch(() => setD({ documents: [], to_read: 0 })); }, []);
  if (!d || d.documents.length === 0) return null;
  const todo = d.documents.filter(x => !x.acknowledged_at);
  const done = d.documents.filter(x => x.acknowledged_at);

  return (
    <div className="bg-card border border-border rounded-lg p-5 border-l-4 border-l-amber-500" data-testid="operative-documents-card">
      <h2 className="text-lg font-semibold flex items-center gap-2 mb-1"><BookOpenText className="h-5 w-5 text-amber-600" weight="fill" /> Policies &amp; documents to read</h2>
      <p className="text-xs text-muted-foreground mb-3">{todo.length ? `${todo.length} to read and sign` : "You're up to date."}</p>
      <div className="space-y-2">
        {todo.map(x => (
          <div key={x.id} className="flex flex-wrap items-center gap-2 text-xs py-1.5 px-2 rounded hover:bg-muted" data-testid={`operative-doc-${x.id}`}>
            <div className="flex-1 min-w-[180px]">
              <p className="font-medium leading-snug">{x.title}</p>
              <p className="text-[11px] text-muted-foreground">{x.type_label} · {x.reference} v{x.version} · {x.section_count} section{x.section_count === 1 ? "" : "s"}{x.has_quiz ? " · 3-question check" : ""}</p>
            </div>
            <Badge className="text-[10px] bg-amber-100 text-amber-800">to read</Badge>
            <Button size="sm" className="h-7" onClick={() => navigate(`/my-work/documents/${x.id}`)} data-testid={`operative-doc-read-${x.id}`}>Read &amp; sign</Button>
          </div>
        ))}
        {done.length > 0 && (
          <div data-testid="operative-docs-done">
            <p className="text-[10px] font-semibold uppercase tracking-wider text-muted-foreground mb-1 mt-2">Signed</p>
            {done.map(x => (
              <button key={x.id} type="button" onClick={() => navigate(`/my-work/documents/${x.id}`)} className="w-full flex flex-wrap items-center gap-x-2 gap-y-0.5 text-xs py-1 px-2 rounded hover:bg-muted text-left" data-testid={`operative-doc-done-${x.id}`}>
                <CheckCircle size={14} weight="fill" className="text-emerald-600 shrink-0" />
                <span className="flex-1 min-w-[160px] leading-snug text-primary hover:underline">{x.title}</span>
                <span className="text-muted-foreground whitespace-nowrap">v{x.version} · signed {fmtDate(x.acknowledged_at)}</span>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
